import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    passwordLengthValidation: translate({ id: 'login-next.resetPassword.validation.length' }),
    passwordExcludesUsernameValidation: translate({
      id: 'login-next.resetPassword.validations.excludesUsername',
    }),
    passwordExcludesReservedTermsValidation: translate({
      id: 'login-next.resetPassword.validations.excludesReservedTerms',
    }),
    passwordExcludesRepeatedPatternsValidation: translate({
      id: 'login-next.resetPassword.validations.excludesRepeatedPatterns',
    }),
  }))

  return api
}
